import type { PcmpChannel } from '../types/pcmpProposal.types';
import type { PcmpMisQueueCounts, PcmpMisView } from '../types/pcmpMis.types';

export const PCMP_MIS_DEFAULT_TAB: PcmpMisView = 'PENDING';

export const PCMP_MIS_TAB_LABELS = {
  PENDING: 'Pending',
  NOT_VERIFIED: 'Not Verified',
  EXPLAINED: 'Explanation Given',
  ACCOUNTS_STAGING: 'Accounts Staging',
  MARKETING_STAGING: 'Marketing Staging',
  BATCHES: 'Batches',
  COMPLETED: 'Completed',
  ON_HOLD: 'On Hold',
} as const satisfies Record<PcmpMisView, string>;

/** The badge of each tab, from the counts endpoint. */
export const PCMP_MIS_TAB_COUNT = {
  PENDING: (counts) => counts.pending,
  NOT_VERIFIED: (counts) => counts.notVerified,
  EXPLAINED: (counts) => counts.explained,
  ACCOUNTS_STAGING: (counts) => counts.accountsStaging,
  MARKETING_STAGING: (counts) => counts.marketingStaging,
  BATCHES: (counts) => counts.batches,
  COMPLETED: (counts) => counts.completed,
  ON_HOLD: (counts) => counts.onHold,
} as const satisfies Record<PcmpMisView, (counts: PcmpMisQueueCounts) => number>;

export const PCMP_MIS_EMPTY_MESSAGE = {
  PENDING: 'Nothing is waiting for MIS verification',
  NOT_VERIFIED: 'No proposals are waiting for an explanation',
  EXPLAINED: 'No explanations to review',
  ACCOUNTS_STAGING: 'No verified proposals waiting for an Accounts batch',
  MARKETING_STAGING: 'No verified proposals waiting for a Marketing batch',
  BATCHES: 'No routing batches found',
  COMPLETED: 'No routed proposals found',
  ON_HOLD: 'No proposals on hold at MIS',
} as const satisfies Record<PcmpMisView, string>;

/** Tabs whose proposals MIS can still Verify or mark Not Verified. */
export const PCMP_MIS_DECIDABLE_TABS: ReadonlySet<PcmpMisView> = new Set([
  'PENDING',
  'NOT_VERIFIED',
  'EXPLAINED',
]);

export const PCMP_MIS_DECISION_COPY = {
  VERIFIED: { label: 'Verify', title: 'Verify Proposal', toast: 'Proposal verified' },
  NOT_VERIFIED: {
    label: 'Not Verified',
    title: 'Mark Not Verified',
    toast: 'Proposal marked Not Verified',
  },
} as const;

/** The staging tabs and the channel (payment source) each stages into. */
export const PCMP_MIS_STAGING_CHANNEL: Partial<Record<PcmpMisView, PcmpChannel>> = {
  ACCOUNTS_STAGING: 'ACCOUNTS',
  MARKETING_STAGING: 'MARKETING',
};

export const PCMP_PRE_BATCH_LABELS = {
  ACCOUNTS: 'Pre-Batch Accounts',
  MARKETING: 'Pre-Batch Marketing',
} as const satisfies Record<PcmpChannel, string>;

export const PCMP_BATCH_STATUS_LABELS = {
  STAGED: 'Staged',
  PUBLISHED: 'Published',
  CLOSED: 'Closed',
} as const;

export const PCMP_BATCH_STATUS_TONE = {
  STAGED: 'warning',
  PUBLISHED: 'success',
  CLOSED: 'neutral',
} as const;
